// lib imports
import React, { FunctionComponent } from 'react';
import { object, string } from 'yup';
import { FormikHelpers, Formik, FormikProps, Field } from 'formik';
import map from 'lodash/map';
import { Grid, Button } from '@inplayer-org/inplayer-ui';

// utils
import isEmpty from 'lodash/isEmpty';

// components
import { QuickAddData } from 'pages/MerchantPages/Assets/assetTypes';
import Input from 'components/Fields/Input';
import FieldError from 'components/Fields/FieldError';
import Select from 'components/Fields/Select';
import IntegrationMessage from '../IntegrationMessage';

const { Container, Cell } = Grid;

interface FormValues {
  videoId: string;
  player: string;
}

const validationSchema = object().shape({
  videoId: string().required('*Required'),
  player: string().required('*Required'),
});

interface OwnProps {
  keys: any;
  onSubmit: (data: QuickAddData) => any;
  jwPlayers?: Array<any>;
  onBackButtonClick: () => void;
}

type Props = OwnProps;

const JwPlayerQuickAdd: FunctionComponent<Props> = ({ onSubmit, jwPlayers, keys, onBackButtonClick }) => {
  const initialValues = {
    videoId: '',
    player: '',
  };

  const onFormSubmit = async (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    await onSubmit(values);
    setSubmitting(false);
  };

  const options = map(jwPlayers, (player) => ({ value: player.key, displayName: player.name, tag: player.name }));

  const isIntegrated: boolean = keys && !isEmpty(keys);

  return isIntegrated ? (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onFormSubmit}
      >
        {({ handleSubmit, isSubmitting, isValid }: FormikProps<FormValues>) => (
          <form onSubmit={handleSubmit}>
            <Container columns={3} rowGap="2rem">
              <Cell width={3}>
                <Container columns={1}>
                  <Cell width={1}>
                    <Field
                      tag="text_input_jwplayer_video_key"
                      name="videoId"
                      type="text"
                      component={Input}
                      label="Video Key"
                    />
                    <FieldError name="videoId" />
                  </Cell>
                  <Cell width={1}>
                    <Field
                      tag="text_input_jwplayer_video_player"
                      name="player"
                      component={Select}
                      isInlineLabelField
                      label="Video Player"
                      defaultOption={{ displayName: 'Select players' }}
                      options={options}
                    />
                    <FieldError name="player" />
                  </Cell>
                </Container>
              </Cell>
              <Cell width={1}>
                <Button
                  tag="button_back"
                  fullWidth
                  buttonModifiers={['buttonLink']}
                  onClick={onBackButtonClick}
                  type="button"
                >
                  Back
                </Button>
              </Cell>
              <Cell width={1} left={3}>
                <Button
                  tag="button_save"
                  fullWidth
                  type="submit"
                  disabled={isSubmitting || !isValid}
                  buttonModifiers={['buttonPrimary']}
                >
                  Save
                </Button>
              </Cell>
            </Container>
          </form>
        )}
      </Formik>
    </>
  ) : (
    <IntegrationMessage ovpType="jwplayer" />
  );
};

export default JwPlayerQuickAdd;
